import React, { Component } from 'react';
import IconClose from '../atoms/IconClose';
import floorPlan from '../assets/images/anzac-floorplan.png';
import { Link } from 'react-router-dom';

class Info extends Component {

  render() {
    return (
      <div className="Info">
        <div className="InfoContent">
          <div className="buttons">
            <Link to="/"><IconClose/></Link>
          </div>
          <h1>The Hall of Service</h1>
          <p className="InfoFloorPlan"><img alt="The Hall of Silence floorplan" src={floorPlan}/></p>
          <p>
            The Hall of Service, at the centre of the Centenary Extension,
            is a civic space that architecturally and artistically mirrors
            the Hall of Silence. The Hall was named in acknowledgement of
            the original Memorial halls and to recognise more than a
            century of Australian service.  
          </p>
          <div className="InfoStatsHolder">
            <p className="InfoStatNumber">1,701</p>
            <p className="InfoStatText">soil samples from NSW towns, cities, <br />suburbs and homesteads</p>
            <p className="InfoStatNumber">100</p>
            <p className="InfoStatText">soil samples from significant <br />military sites across the world</p>
          </div>
          <p>
            This interactive includes enlistee names sourced from
            {' '}
            <a
              href="https://www.aif.adfa.edu.au/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              The AIF Project
            </a>.
            Please note, this interactive does not contain a complete record
            of First World War enlistees from New South Wales.
          </p>
          <blockquote>
            <p className="quote">
              “My resolution of the space is an artwork, but for me the benchmark
              of its success, now and over the long term, will reside not in its
              authorship but in its capacity to enable viewers to feel a deep
              connection and resonance with our service given in the face of war.”
            </p>
            <p className="person">&mdash; Fiona Hall, artist</p>
          </blockquote>
          <a
            className="button"
            href="https://www.anzacmemorial.nsw.gov.au/explore-memorial/hall-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more about the artwork
          </a>
        </div>
      </div>
    )
  }
}

export default Info;